import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import CloseVirtualCardContent from 'src/app/CloseVirtualCardContent/CloseVirtualCardContent'
import { selectVirtualCardIdFromRoute } from 'src/app/CloseVirtualCardContent/redux/closeVirtualCardContent.selectors'
import { useFlyoutDispatch } from 'src/hooks'
import { connectedReplace } from 'src/navigation/Lnk'
import { closeBillPayCardUrl } from 'src/navigation/urls'
import {
  useQueryVirtualCardDetail,
  useQueryVirtualCardPermissions,
} from 'src/queries/virtualCards.queries'

const CloseVirtualCard: React.FC = (): React.ReactElement => {
  const dispatch = useFlyoutDispatch()
  const virtualCardId = useSelector(selectVirtualCardIdFromRoute)
  const { data: virtualCard } = useQueryVirtualCardDetail({ virtualCardId })

  useQueryVirtualCardPermissions({ virtualCardId })

  useEffect(() => {
    if (virtualCard === undefined) return

    if (virtualCard.isBillPay) {
      // user is trying to access a bill pay card, redirect to the bill pay url
      dispatch(connectedReplace(closeBillPayCardUrl(virtualCardId)))
    }
  }, [virtualCard])

  return (
    <CloseVirtualCardContent
      virtualCardId={virtualCardId}
      virtualCard={virtualCard}
    />
  )
}

export default CloseVirtualCard
